import { createSlice } from "@reduxjs/toolkit";
import Cookies from 'js-cookie';

function safeParse(value) {
    if (value) {
        try {
            return JSON.parse(value);
        } catch {
            return null;
        }
    }
    return null;
}

const authSlice = createSlice({
    name: 'auth',
    initialState: {user: safeParse(Cookies.get('auth_user')), access_token: Cookies.get('auth_access_token')},
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
            state.access_token = action.payload.access_token;
            Cookies.set('auth_user', JSON.stringify(state.user));
            Cookies.set('auth_access_token', state.access_token);
        },
        logOut: (state, action) => {
            state.user = null;
            Cookies.set('auth_user', null);
            Cookies.set('auth_access_token', null);
        }
    }
})

export const {setUser, logOut} = authSlice.actions

export default authSlice.reducer

export const getUser = (state) => state.auth.user